export default "__VITE_ASSET__CX1rOqCr__"